import { QueryClient, QueryClientProvider } from 'react-query';
import { getDynamicComponents } from 'components';
import ErrorBoundary from 'components/esadir/ErrorBoundary';
import ServicesProvider from 'context/ServicesProvider';
import ViewportProvider from 'context/corporatiu/ViewportProvider';
import styles from '../../../web/styles/esadir/globals.module.scss';
import PublicitatProvider from 'context/PublicitatProvider';
import { useState } from 'react';
const DynamicComponents = getDynamicComponents('esadir');

const Appesadir = ({ Component, pageProps }) => {
    const [queryClient] = useState(() => new QueryClient());

    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <ServicesProvider>
                    <PublicitatProvider>
                        <ViewportProvider {...pageProps}>
                            <div id='__mainContent' className={styles.esadir}>
                                <Component {...pageProps} dynamicComponents={DynamicComponents} />
                            </div>
                        </ViewportProvider>
                    </PublicitatProvider>
                </ServicesProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

export default Appesadir;
